/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JobDetails } from '@app/app/page-modules/admin/components/mentors/admin-mentors.model';

export interface JobsTimelineDialogData {
  userName: string;
  jobs: JobDetails[];
}

@Component({
  selector: 'ptl-jobs-timeline-dialog',
  templateUrl: './jobs-timeline-dialog.component.html',
  styleUrls: ['./jobs-timeline-dialog.component.scss'],
})
export class JobsTimelineDialogComponent {
  sortedJobs: JobDetails[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: JobsTimelineDialogData,
    private dialogRef: MatDialogRef<JobsTimelineDialogComponent>,
  ) {
    this.sortedJobs = this.sortJobsByDate(data.jobs);
  }

  close(): void {
    this.dialogRef.close();
  }

  isJobActive(job: JobDetails): boolean {
    if (!job.endDate) {
      return true;
    }
    return new Date(job.endDate) >= new Date();
  }

  trackByJobId(index: number, job: JobDetails): string {
    return job._id;
  }

  private sortJobsByDate(jobs: JobDetails[]): JobDetails[] {
    return [...jobs].sort((a, b) => {
      if (!a.endDate && !b.endDate) return 0;
      if (!a.endDate) return -1;
      if (!b.endDate) return 1;

      const dateA = new Date(a.endDate).getTime();
      const dateB = new Date(b.endDate).getTime();
      return dateB - dateA;
    });
  }
}
